import React from 'react';
import { CnStatisticAvatarBaseProps, CnStatisticAvatarProps } from './types';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticAvatarBase({ src, CnFormat }: CnStatisticAvatarBaseProps) {
  return (
    <div className="avatar">
      <CnFormat
        {...{
          src,
        }}
        format="CnFormatImage"
      />
    </div>
  );
}
export { CnStatisticAvatarBase };
export type { CnStatisticAvatarProps };
